export type ToggleSwitchPreviewState =
  | 'default'
  | 'hover'
  | 'focused'
  | 'disabled'

export type ToggleSwitchValueState = 'off' | 'on'

export const TOGGLE_SWITCH_PREVIEW_STATES: ToggleSwitchPreviewState[] = [
  'default',
  'hover',
  'focused',
  'disabled',
]

export const TOGGLE_SWITCH_PREVIEW_STATE_LABELS: Record<
  ToggleSwitchPreviewState,
  string
> = {
  default: 'Default',
  hover: 'Hover',
  focused: 'Focused',
  disabled: 'Disabled',
}

export const TOGGLE_SWITCH_VALUE_STATES: ToggleSwitchValueState[] = [
  'off',
  'on',
]

export const TOGGLE_SWITCH_VALUE_STATE_LABELS: Record<
  ToggleSwitchValueState,
  string
> = {
  off: 'Off',
  on: 'On',
}

export type ToggleSwitchProps = {
  checked?: boolean
  defaultChecked?: boolean
  disabled?: boolean
  className?: string
  id?: string
  'aria-label'?: string
  /** Kept for API parity; toggle uses the same (light) styling in both modes. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: ToggleSwitchPreviewState
  onChange?: (checked: boolean) => void
}
